import React, { useEffect, useState } from 'react';
import Heart from "../../../../Assets/Images/HEART.png";
import Soul from "../../../../Assets/Images/SOUL.png";
import Mind from "../../../../Assets/Images/MIND.png";
import Strength from "../../../../Assets/Images/STRENGTH.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

const initialData = [
  { quadrant: 'HEART', no: 1, question: "When presented with a problem, I am most concerned with how the team is handling it.", score: 1 },
  { quadrant: 'SOUL', no: 1, question: "My superpower is to rise above any situation to gain a wise perspective.", score: 2 },
  { quadrant: 'MIND', no: 1, question: "When presented with a problem, I need to understand the processes before starting.", score: 3 },
  { quadrant: 'STRENGTH', no: 1, question: "When presented with a problem, I immediately start working on it.", score: 4 },
  { quadrant: 'SOUL', no: 2, question: "I evaluate decisions by their ability to fulfill the greater vision.", score: 2 },
  { quadrant: 'MIND', no: 2, question: "I make decisions based on the policies that guide me.", score: 3 },
  { quadrant: 'STRENGTH', no: 2, question: "I make decisions by focusing on what needs to get done.", score: 4 },
  { quadrant: 'HEART', no: 2, question: "I ensure my decisions are measured by whether everyone is on board.", score: 1 },
  { quadrant: 'STRENGTH', no: 3, question: "I feel most fulfilled when I get my tasks completed.", score: 4 },
  { quadrant: 'HEART', no: 3, question: "I feel most fulfilled when I am surrounded by my people.", score: 1 },
  { quadrant: 'SOUL', no: 3, question: "I am most fulfilled when I feel like I am living out my greater purpose.", score: 2 },
  { quadrant: 'MIND', no: 3, question: "I am most fulfilled when a project works like it was planned.", score: 3 },
  { quadrant: 'MIND', no: 4, question: "I am motivated when everything has been thoughtfully planned out.", score: 3 },
  { quadrant: 'STRENGTH', no: 4, question: "I am motivated by winning.", score: 4 },
  { quadrant: 'HEART', no: 4, question: "I am motivated when I feel a sense of belonging.", score: 1 },
  { quadrant: 'SOUL', no: 4, question: "I am motivated by opportunities that develop depth of character.", score: 2 },
  { quadrant: 'STRENGTH', no: 5, question: "I rely heavily on my drive to complete a project.", score: 4 },
  { quadrant: 'SOUL', no: 5, question: "I rely heavily on the meaning of my story when working on a project.", score: 2 },
  { quadrant: 'MIND', no: 5, question: "I need clear responsibilities to function well in my work.", score: 3 },
  { quadrant: 'HEART', no: 5, question: "I rely heavily on passion when working on a project.", score: 1 },
  { quadrant: 'MIND', no: 6, question: "My superpower is analyzing the solution to a problem.", score: 3 },
  { quadrant: 'HEART', no: 6, question: "I believe a collaborative team is the best way to achieve results.", score: 1 },
  { quadrant: 'SOUL', no: 6, question: "I believe our work should connect to a larger purpose.", score: 2 },
  { quadrant: 'STRENGTH', no: 6, question: "I respect people who deliver results.", score: 4 },
  { quadrant: 'SOUL', no: 7, question: "I am always searching for the reasons “why” I am doing something.", score: 2 },
  { quadrant: 'STRENGTH', no: 7, question: "I gain the most satisfaction when I reach my goals.", score: 4 },
  { quadrant: 'HEART', no: 7, question: "I want to feel connected to others when I am doing something.", score: 1 },
  { quadrant: 'MIND', no: 7, question: "I find satisfaction in developing standardized procedures.", score: 3 },
  { quadrant: 'HEART', no: 8, question: "When working on a project, I can become too emotionally invested.", score: 1 },
  { quadrant: 'MIND', no: 8, question: "When working on a project, I can get stuck by overthinking everything.", score: 3 },
  { quadrant: 'STRENGTH', no: 8, question: "I can lose momentum without clear, measurable goals.", score: 4 },
  { quadrant: 'SOUL', no: 8, question: "I struggle to stay engaged when the work has no clear purpose.", score: 2 },
  { quadrant: 'SOUL', no: 9, question: "I am drawn to people who are visionaries.", score: 2 },
  { quadrant: 'HEART', no: 9, question: "My strong feelings sometimes overwhelm my good judgment.", score: 1 },
  { quadrant: 'MIND', no: 9, question: "I believe the right structures are essential for an effective organization.", score: 3 },
  { quadrant: 'STRENGTH', no: 9, question: "I like turning good ideas into action.", score: 4 },
  { quadrant: 'STRENGTH', no: 10, question: "I take satisfaction in a hard day's work.", score: 4 },
  { quadrant: 'MIND', no: 10, question: "I find satisfaction in developing effective systems.", score: 3 },
  { quadrant: 'SOUL', no: 10, question: "I find satisfaction in sharing meaningful stories that impact people's lives.", score: 2 },
  { quadrant: 'HEART', no: 10, question: "When I share a proposal, I want to know 'who' is with me.", score: 1 },
];

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'HEART':
      return <img src={Heart} alt="Heart" className="logo" />;
    case 'SOUL':
      return <img src={Soul} alt="Soul" className="logo" />;
    case 'MIND':
      return <img src={Mind} alt="Mind" className="logo" />;
    case 'STRENGTH':
      return <img src={Strength} alt="Strength" className="logo" />;
    default:
      return null;
  }
};

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const QF_ItemTwoPage = ({ apiData, pageNumber }) => {
  const [dynamicData, setDynamicData] = useState([...initialData]);

  useEffect(() => {
  if (!apiData || !apiData.variables || !apiData.variables.length) {
    setDynamicData(initialData);
    return;
  }

  // Step 1: Parse and store all relevant data from variables
  const questions = [];

  apiData.variables.forEach(item => {
    const match = item.variable?.match(/^st(\d+)_self_pass([12])$/);
    if (!match) return;

    const rawNo = parseInt(match[1]);
    const passType = match[2]; // "1" or "2"

    let actualScore;
    let actualQuestionNo;

    // Determine if primary (1–10) or secondary (11–20)
    if (rawNo >= 1 && rawNo <= 10) {
      actualScore = passType === "1" ? 4 : 1; 
      actualQuestionNo = rawNo;
    } else if (rawNo >= 11 && rawNo <= 20) {
      actualScore = passType === "1" ? 3 : 2; 
      actualQuestionNo = rawNo - 10;
    } else {
      return; 
    }

    // Store only valid items with proper mapping
    questions.push({
      questionNo: actualQuestionNo,
      rawNo: rawNo,
      passType,
      actualScore,
      updatedAt: item.updatedAt,
      variable: item.variable,
      score: item.score,
    });
  });

  // Create a map to store the latest scores, prioritizing round 2 (st11-st20)
  const latestScoresMap = new Map();
  
  questions.forEach(question => {
    const key = `${question.questionNo}_${question.score}`; // Combine questionNo and score for unique key
    const existing = latestScoresMap.get(key);
    
    // If no existing entry or if current question is from round 2 (rawNo > 10)
    if (!existing || question.rawNo > 10) {
      latestScoresMap.set(key, question);
    }
  });

  // Update initialData based on latestScoresMap
  const updatedData = initialData.map(item => {
    // Find matching question from the map
    const matchingQuestion = Array.from(latestScoresMap.values())
      .find(q => q.questionNo === item.no && q.score === item.score);

    return {
      ...item,
      score: matchingQuestion ? matchingQuestion.actualScore : '-'
    };
  });

  // console.log("Final Updated Data for Page 2:", updatedData);
  setDynamicData(updatedData);
}, [apiData]);

  const categoryLabels = ["DRIVERS", "GO-TO'S", "GUIDING PRINCIPLES", "MEANING"];
  const categoryColors = ["#394554", "#666666"]; 

  const pageTwoCategories = [];
  const remaining = dynamicData.slice(12, 28); 
  for (let i = 0; i < remaining.length; i += 4) {
    const rows = remaining.slice(i, i + 4);
    if (!rows.length) break;
    const idx = i / 4;
    pageTwoCategories.push({
      label: categoryLabels[idx % categoryLabels.length],
      color: categoryColors[idx % categoryColors.length],
      rows,
    });
  }


  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div className="page">
        <div className="content">
          <div className="table">
            <table>
              <thead>
                <tr className="tableHeader">
                  <th className="cellBandHeader"></th>
                  <th className="cellIndex">#</th>
                  <th className="cellQuadrant">Quadrant</th>
                  <th className="cellLogo"></th>
                  <th className="cellQuestion-self">Question</th>
                  <th className="cellScore" style={{ padding: "0 5px" }}>Score</th>
                </tr>
              </thead>
              <tbody>
                {pageTwoCategories.map((category, catIdx) =>
                  category.rows.map((item, rowIdx) => {
                    const rowNumber = 13 + catIdx * 4 + rowIdx;
                    const isCategoryStart = rowIdx === 0;
                    const isCategoryEnd = rowIdx === category.rows.length - 1;
                    const rowClass = `tableRow ${isCategoryStart ? 'categoryStart' : ''} ${isCategoryEnd ? 'categoryEnd' : ''}`.trim();

                    return (
                      <tr key={`${category.label}-${rowIdx}`} className={rowClass}>
                        {isCategoryStart && (
                          <td
                            className="cellBand categoryBand"
                            rowSpan={category.rows.length || 4}
                            style={{ backgroundColor: category.color }}
                          >
                            <span className="bandLabel">{category.label}</span>
                          </td>
                        )}
                        <td className="cellIndex">{rowNumber}.</td>
                        <td className="cellQuadrant">{item.quadrant}</td>
                        <td className="cellLogo">{Logo(item.quadrant)}</td>
                        <td className="cellQuestion-self">{item.question}</td>
                        <td className="cellScore">{typeof item.score === 'number' ? item.score : '-'}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} />
    </div>
  );
};

export default QF_ItemTwoPage;
